import { GET_MW_TRANSACTION_BY_INVOICE_NUMBER } from "./actions";

function getSequenceNumber(transaction) {
  return transaction?.sequencenumber ?? transaction?.SequenceNumber ?? null;
}

export function MWTransactionsReducer(state = { bySequenceNumber: {} }, action) {
  switch (action.type) {
    case `${GET_MW_TRANSACTION_BY_INVOICE_NUMBER}_FULFILLED`: {
      const data = action.payload.data;
      const transactions = Array.isArray(data) ? data : [data];
      const bySequenceNumber = { ...state.bySequenceNumber };
      transactions.forEach((tx) => {
        const key = getSequenceNumber(tx);
        if (key != null) {
          bySequenceNumber[key] = tx;
        }
      });
      return { ...state, bySequenceNumber };
    }
    default:
      return state;
  }
}
